// extracted by mini-css-extract-plugin
export default {"documentContainer":"documents_documentContainer__Y9qtv"};